import { v4 as uuidv4 } from "uuid";
import { Identifiable } from "@lifeat/shared/data-models/definition";
import { TaskItemType } from "@lifeat/shared/task-management/TaskManagementTypes";
import { TAG_CHARACTER_LIMIT } from "@lifeat/shared/task-management/TaskTagConstants";
import { Tag } from "@lifeat/shared/task-management/TaskTagTypes";
import { TagValidationError } from "@lifeat/shared/task-management/TaskTagUtil";
import { getDateIsoString } from "@lifeat/shared/util/DateUtil";
import { ClientTaskItemType } from "./TaskManagementTypes";

const TASK_UUID_PREFIX = "clientTaskId";

export const getDraftTaskUID = () => {
    return `${TASK_UUID_PREFIX}-${uuidv4()}`;
};

export type DraftTaskInitializationParams = Pick<TaskItemType, "clientId" | "orderRank" | "tagId" | "projectId"> & {
    scheduleDate?: Date;
};

/**
 * Creates a task in draft state.
 */
export const buildDraftTask = ({
    clientId,
    orderRank,
    scheduleDate,
    tagId,
    projectId,
}: DraftTaskInitializationParams): ClientTaskItemType => {
    return {
        type: "singular",
        title: "",
        status: "OPEN",
        orderRank: orderRank,
        creationTimestamp: new Date().toISOString(),
        clientId: clientId,
        tagId,
        projectId,
        isDraft: true,
        ...(scheduleDate && {
            schedulingDetails: {
                scheduleDate: getDateIsoString(scheduleDate),
            },
        }),
    };
};

export function translateInputValidationError(validationError: TagValidationError, tagNameInput: string): string {
    switch (validationError) {
        case TagValidationError.TagNameConflict:
            return "This tag name has already been taken";
        case TagValidationError.TagNameCharacterLimit:
            return `${tagNameInput.length}/${TAG_CHARACTER_LIMIT} chars`;
        case TagValidationError.TagNameEmpty:
            return "Tag name can’t be empty";
        default:
            return "Invalid tag name";
    }
}

export const getTaskTagFromTagArray = (
    taskTagId: string | undefined | null,
    tags: Identifiable<Tag>[],
): Tag | undefined => {
    return taskTagId ? tags.find((tag) => tag.id === taskTagId)?.document : undefined;
};
